module.exports = __webpack_public_path__ + "img/map-location-small-fr.2ed7d3d3.jpg";